import React, { useContext, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { constants } from 'constants/Constants';
import KpiDefinitionDrawer from 'components/KpiDefinitionDrawer/KpiDefinitionDrawer';
import KpiDefinitionData from 'service/KpiDefinitionData';
import TimeMetricsCard from '../../../components/TimeMetricsCard';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import { useOverview } from '../../../hooks/overview-hook';
import { helperFunctions } from 'utils/helperFunctions';
import { useMetricsCriteria } from 'hooks/useMetricsCriteria';
import { ThemeContext } from '../../../context/ThemeContext';
import * as Styled from './style';

interface GPGUserAdoptionScorecardProps {
  // Add any props if needed
}

const GPGUserAdoptionScorecard: React.FC<
  GPGUserAdoptionScorecardProps
> = () => {
  const { mode } = useContext(ThemeContext);
  const { selectedProduct } = useContext(FilterContext);
  const { operationalMetricCriteria } = useMetricsCriteria();
  const {
    userBehaviorAndEngagementData,
    getUserBehaviourAndEngagementData,
    userBehaviorAndEngagementLoading,
  } = useOverview();

  const defaultMarketOption = { label: 'All', value: 999999 };
  const defaultSectorOption = { label: 'All', value: 99 };
  const defaultProductOption = { label: 'All', value: 9999 };

  useEffect(() => {
    const overviewMetricCriteria = {
      ...operationalMetricCriteria,
    };
    overviewMetricCriteria.productId = defaultProductOption?.value;
    overviewMetricCriteria.sectorId = defaultSectorOption?.value;
    overviewMetricCriteria.marketId = defaultMarketOption?.value;
    getUserBehaviourAndEngagementData({
      variables: {
        overviewMetricCriteria,
      },
    });
  }, [getUserBehaviourAndEngagementData, operationalMetricCriteria]);

  const {
    getValueAbbreviationParser,
    getRoundedValueForDecimal,
    getNAForPercentageValue,
  } = helperFunctions();

  const userAdoptionMetricsData = [
    {
      value: getValueAbbreviationParser(
        userBehaviorAndEngagementData?.userBehaviour?.activeUser
      ),
      title: constants.userBehavior.activeUsers,
    },
    {
      value: getValueAbbreviationParser(
        userBehaviorAndEngagementData?.userBehaviour?.totalUser
      ),
      title: constants.overview.totalUsers,
    },
    {
      value: getNAForPercentageValue(
        getRoundedValueForDecimal(
          userBehaviorAndEngagementData?.userBehaviour?.adoptionRatePercentage
        )
      ),
      title: constants.userBehavior.adoptionRateUserBehavior,
    },
  ];

  return (
    <Styled.DTCOverviewContainer
      data-testid="gpg-useradoption-overview-container"
      mode={mode}
    >
      <Grid item xs={12}>
        <Typography className="header">
          {constants?.overview?.userAdoption}{' '}
          <KpiDefinitionDrawer
            title={constants?.overview?.userAdoption}
            KpiDefinitionList={
              KpiDefinitionData[selectedProduct?.productId]?.overview
                ?.userAdoption ?? []
            }
          />
        </Typography>
        <TimeMetricsCard
          metricsData={userAdoptionMetricsData}
          userBehaviorAndEngagementLoading={userBehaviorAndEngagementLoading}
          KpiDefinitionList={
            KpiDefinitionData[selectedProduct?.productId]?.overview
              ?.userAdoption ?? []
          }
          showKpiDefinition={false}
          mode={mode}
        />
      </Grid>
    </Styled.DTCOverviewContainer>
  );
};

export default GPGUserAdoptionScorecard;
